module.exports = new Promise((resolve, reject) => {
          const envUrl = window._env_?.PROJECTS_URL;
          const isDev = !envUrl || envUrl.startsWith('$');
          const remoteUrl = isDev ? 'http://localhost:3001' : envUrl;

          // In production build, fail if no valid URL is provided
          if (true && isDev) {
            console.error('[Module Federation] PROJECTS_URL not configured for production');
            reject(new Error('Projects MFE is not configured'));
            return;
          }

          const script = document.createElement('script');
          script.src = remoteUrl + '/remoteEntry.js?v=' + Date.now();
          script.onload = () => {
            resolve(window.projects);
          };
          script.onerror = () => {
            console.error('[Module Federation] Failed to load projects remote from:', remoteUrl);
            reject(new Error('Failed to load Projects MFE'));
          };
          document.head.appendChild(script);
        });